import { useEffect, useState } from 'react';
import { useKeptState } from './keptState';

/**
 * Пауза в наборе перед запросом: без неё список перезапрашивается на каждое
 * нажатие. Одна на все поиски приложения — до выноса это число было объявлено
 * трижды (имущество, реестр, внешки), а у поиска по участникам задержки не
 * было вовсе, и он честно ходил на сервер за каждой буквой.
 */
const SEARCH_DELAY_MS = 350;

/**
 * Строка поиска, доезжающая до запроса с задержкой.
 *
 * Ищет всегда СЕРВЕР — списки постраничные, и фильтровать загруженную
 * страницу значит врать про остальные. Поэтому наружу отдаются две величины:
 * `input` для поля (перерисовывается на каждую букву) и `term` для запроса
 * (уже обрезанный и отстоявший паузу) — его и кладут в зависимости загрузчика.
 * `keepAs` — имя, под которым строка переживёт возврат на экран (useKeptState).
 */
export function useSearchTerm(keepAs?: string) {
  const [input, setInput] = useKeptState(keepAs, '');
  // Сохранённую строку ищем сразу: ждать паузу заново значит сперва показать весь список.
  const [term, setTerm] = useState(() => input.trim());

  useEffect(() => {
    const timer = window.setTimeout(() => setTerm(input.trim()), SEARCH_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [input]);

  return { input, setInput, term };
}
